import React, { Component } from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch } from "react-router-dom";
import HomeV1 from "./components/home-v1";
import HomeV2 from "./components/home-v2";
import Webstories from "./components/Webstories";
import HomeV3 from "./components/home-v3";
import CatPage from "./components/cat-page";
import CatSports from "./components/cat-sports";
import lifeStyle from "./components/cat-life-style";
import Fashion from "./components/cat-fashion";
import Author from "./components/author";
import Error from "./components/error";
import Blog from "./components/blog";
import BlogDetails from "./components/blog-details";
import Home_V2 from "./components/home-v2";
import { AppProvider } from "./AppContext";
import PodcastDetails from "./components/section-components/PodcatsDetails";
import NotificationPanel from "./components/NotificationPanel ";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"; 
import ScrollToTop from "./components/ScrollToTop";

class Root extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInstallButton: false,
    };
    this.deferredPrompt = null;
  }

  componentDidMount() {
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();

      // Save the event
      this.deferredPrompt = e;

      // Check if on mobile
      if (this.isMobileDevice()) {
        setTimeout(() => {
          this.setState({ showInstallButton: true });
        }, 10);
      }
    });
  }

  isMobileDevice = () => {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
      navigator.userAgent
    );
  };

  handleInstallClick = () => {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();

      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        } else {
          console.log("User dismissed the A2HS prompt");
        }
        this.deferredPrompt = null;
        this.setState({ showInstallButton: false });
      });
    }
  };

  render() {
    return (
      <AppProvider>
        <HashRouter basename="/">
          <ScrollToTop />

          <div>
            <Switch>
              <Route exact path="/" component={Home_V2} />
              <Route path="/home-v2" component={HomeV2} />
              <Route path="/रुबरू-with-राजीव" component={PodcastDetails} />
              <Route path="/home-v3" component={HomeV3} />
              <Route path="/cat-page" component={CatPage} />
              <Route path="/category/:categoryName" component={CatSports} />
              <Route path="/cat-life-style" component={lifeStyle} />
              <Route path="/cat-fashion" component={Fashion} />
              <Route path="/author" component={Author} />
              <Route path="/error" component={Error} />
              <Route path="/blog" component={Blog} />
              <Route path="/web-stories" component={Webstories} />
              <Route path="/news-details/:id" component={BlogDetails} />
            </Switch>

            {this.state.showInstallButton && (
              <div
                style={{
                  position: "fixed",
                  bottom: "20%",
                  right: "0px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                  textAlign: "center",
                  zIndex: 1000,
                  borderRadius: "18px",
                }}
              >
                {/* <button
      onClick={() => this.setState({ showInstallButton: false })}
      style={{
        position: "absolute",
        right: "10px",
        top: "5px",
        background: "transparent",
        border: "none",
        fontSize: "18px",
        cursor: "pointer",
        color: "#333"
      }}
      aria-label="Close install prompt"
    >
      ×
    </button> */}
                <button
  onClick={this.handleInstallClick}
  style={{
    background: "#004ebc",
    border: "none",
    color: "#fff",
    borderTopLeftRadius: "18px",
    borderBottomLeftRadius: "18px",
    padding: "5px 15px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "2px",
    animation: "blink 1s infinite", // 👈 animation added here
  }}
>
  <i className="fas fa-download"></i>
  <p style={{ color: "#fff", margin: "0" }}>ऐप</p>
</button>

              </div>
            )}
          </div>
          <NotificationPanel />
        </HashRouter>
      </AppProvider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("nextpage"));

// ✅ Register the Service Worker
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (window.confirm("New version available. Refresh to update?")) {
      registration.waiting?.postMessage({ type: "SKIP_WAITING" });
      window.location.reload();
    }
  },
});
